/* filter data for shipment */


export const namespaced = true

export const state = {
    retailer_id_list:[],
    wholesaler_id_list :[],
    status_list :[],
    type_list :[],
    filter_date_from : "",
    filter_date_to : "",
    filter_count:0,
}

export const mutations = {
    SET_SHIPMET_FILTER(state, {
        retailer_id_list,
        wholesaler_id_list,
        status_list,
        type_list,
        filter_date_from,
        filter_date_to,
        filter_count,
    }) {
        state.retailer_id_list = retailer_id_list
        state.wholesaler_id_list = wholesaler_id_list
        state.status_list = status_list
        state.type_list = type_list
        state.filter_date_from = filter_date_from
        state.filter_date_to = filter_date_to
        state.filter_count = filter_count
    },
}
export const actions = {
    setShipmentFilter({
        commit
    }, items) {
        commit('SET_SHIPMET_FILTER', items)
    },
}
export const getters = {
    getShipmentFilter: state => {
        return state;
    },
}